import {
    ImageryProviderParameterType,
    LayerTypeOptionsByTypeName,
} from 'app/overview/config/data/MapLayerOptionsHelper';

export const imageryLayerDefinitions = {
    tms: {
        isDefaultType: true,
        call: 'createTileMapServiceImageryProvider',
        pretty: 'Tile Map Service',
        required: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.URL,
                mapParam: 'url',
            },
        ],
        optional: [
            {
                prettyParam: 'File Extension',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'fileExtension',
                defaultValue: 'png',
            },
            {
                prettyParam: 'Minimum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'minimumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Tile Width',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileWidth',
                defaultValue: 256,
            },
            {
                prettyParam: 'Tile Height',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileHeight',
                defaultValue: 256,
            },
            {
                prettyParam: 'Flip X/Y',
                type: ImageryProviderParameterType.BOOLEAN,
                mapParam: 'flipXY',
                defaultValue: false,
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    arcgis: {
        call: 'ArcGisMapServerImageryProvider',
        pretty: 'ArcGis',
        required: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.URL,
                mapParam: 'url',
            },
        ],
        optional: [
            {
                prettyParam: 'Token',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'token',
            },
            {
                prettyParam: 'Use Precached Tiles (If Available)',
                type: ImageryProviderParameterType.BOOLEAN,
                mapParam: 'usePrecachedTilesIfAvailable',
                defaultValue: true,
            },
            {
                prettyParam: 'Layers',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'layers',
            },
            {
                prettyParam: 'Enable Pick Features',
                type: ImageryProviderParameterType.BOOLEAN,
                mapParam: 'enablePickFeatures',
                defaultValue: true,
            },
            {
                prettyParam: 'Tile Width',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileWidth',
                defaultValue: 256,
            },
            {
                prettyParam: 'Tile Height',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileHeight',
                defaultValue: 256,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    osm: {
        pretty: 'Open Street Map',
        call: 'createOpenStreetMapImageryProvider',
        required: [],
        optional: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.URL,
                mapParam: 'url',
            },
            {
                prettyParam: 'File Extension',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'fileExtension',
                minimumLevel: ImageryProviderParameterType.NUMBER,
                defaultValue: 'png',
            },
            {
                prettyParam: 'Minimum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'minimumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    wmts: {
        pretty: 'Web Map Tile Service',
        call: 'WebMapTileServiceImageryProvider',
        required: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.WMS_URL,
                mapParam: 'url',
            },
            {
                prettyParam: 'Layers',
                type: ImageryProviderParameterType.IMS_DROPDOWN,
                mapParam: 'layers',
                defaultValue: '0',
                childProps: {
                    isMulti: true,
                    grouping: true,
                },
            },
            {
                prettyParam: 'Style',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'style',
            },
            {
                prettyParam: 'Tile Matrix Set ID',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'tileMatrixSetID',
            },
        ],
        optional: [
            {
                prettyParam: 'Format',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'format',
                defaultValue: 'image/jpeg',
            },
            {
                prettyParam: 'Tile Matrix Labels (CSV)',
                type: ImageryProviderParameterType.ARRAY,
                mapParam: 'tileMatrixLabels',
            },
            {
                prettyParam: 'Tile Width',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileWidth',
                defaultValue: 256,
            },
            {
                prettyParam: 'Tile Height',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileHeight',
                defaultValue: 256,
            },
            {
                prettyParam: 'Minimum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'minimumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
            },
            {
                prettyParam: 'SubDomain',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'subdomains',
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    ion: {
        pretty: 'Cesium Ion',
        call: 'IonImageryProvider',
        required: [
            {
                prettyParam: 'Asset ID',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'assetId',
            },
        ],
        optional: [
            {
                prettyParam: 'Access Token',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'accessToken',
            },
            {
                prettyParam: 'Server',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'server',
            },
        ],
    },
    mapbox: {
        pretty: 'Map Box',
        call: 'MapboxImageryProvider',
        required: [
            {
                prettyParam: 'Map ID',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'mapId',
            },
        ],
        optional: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'url',
                defaultValue: 'https://api.mapbox.com/v4/',
            },
            {
                prettyParam: 'Access Token',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'accessToken',
            },
            {
                prettyParam: 'Format',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'server',
                defaultValue: 'png',
            },
            {
                prettyParam: 'Minimum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'minimumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    wms: {
        pretty: 'Web Map Service',
        call: 'WebMapServiceImageryProvider',
        required: [
            {
                prettyParam: 'url',
                type: ImageryProviderParameterType.WMS_URL,
                mapParam: 'url',
            },
            {
                prettyParam: 'Layers',
                type: ImageryProviderParameterType.IMS_DROPDOWN,
                mapParam: 'layers',
                defaultValue: '0',
                childProps: {
                    isMulti: true,
                    grouping: true,
                },
            },
        ],
        optional: [
            {
                prettyParam: 'Tile Width',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileWidth',
                defaultValue: 256,
            },
            {
                prettyParam: 'Tile Height',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'tileHeight',
                defaultValue: 256,
            },
            {
                prettyParam: 'Access Token',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'accessToken',
            },
            {
                prettyParam: 'Format',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'server',
                defaultValue: 'png',
            },
            {
                prettyParam: 'Minimum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'minimumLevel',
                defaultValue: 0,
            },
            {
                prettyParam: 'Maximum Level',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'maximumLevel',
            },
            {
                prettyParam: 'CRS',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'crs',
            },
            {
                prettyParam: 'SRS',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'srs',
            },
            {
                prettyParam: 'Subdomains',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'subdomains',
            },
            {
                prettyParam: 'Enable Pick Features',
                type: ImageryProviderParameterType.BOOLEAN,
                mapParam: 'enablePickFeatures',
                defaultValue: true,
            },
            {
                prettyParam: 'Credit',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'credit',
                defaultValue: '',
            },
        ],
    },
    singletile: {
        pretty: 'Single Tile',
        call: 'SingleTileImageryProvider',
        required: [
            {
                prettyParam: 'URL',
                type: ImageryProviderParameterType.STRING,
                mapParam: 'url',
            },
            {
                prettyParam: 'Latitude of center',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'latitude_of_center',
            },
            {
                prettyParam: 'Longitude of center',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'longitude_of_center',
            },
            {
                prettyParam: 'Width (m)',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'width_metres',
            },
            {
                prettyParam: 'Height (m)',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'height_metres',
            },
            {
                prettyParam: 'Rotation (deg)',
                type: ImageryProviderParameterType.NUMBER,
                mapParam: 'rotation_degrees',
                defaultValue: 0,
            },
        ],
        optional: [],
    },
} as const satisfies LayerTypeOptionsByTypeName;
